// extracted by mini-css-extract-plugin
export default {"Shadow":"NewCustomer_Shadow__hd1Y+"};